import React, { useState, useEffect, useRef } from "react";
//import axios from "axios";
import { motion } from "framer-motion";
import "./ChatBoard.css";
import {  toast } from "react-toastify";

const SpadaChatbot = () => {
    const [messages, setMessages] = useState([]);
    const [input, setInput] = useState("");
    const [isOpen, setIsOpen] = useState(false);
    
    const messagesEndRef = useRef(null);

    const [orderCount, setOrderCount] = useState(1);
    const handleSendMessage = async () => {
       // debugger;
        
        if (!input.trim()) return;
    
        const newMessage = { user: "User", text: input };
        setMessages(prevMessages => [...prevMessages, newMessage]);
    
        const formData = {
            message: input,
            orderCount:orderCount,
          };
        try {
           
            const response = await fetch("https://apitest.spadez.co/api/contact/SaveContactMessage", {
                method: "POST",
                headers: {
                  "Content-Type": "application/json",
                },
                body: JSON.stringify(formData),
              });
          
              const result = await response.json();
              //const botMessage="";
              
            if (response.ok) {
                setMessages(prevMessages => [
                    ...prevMessages,
                    { user: "", text: result.message }
                ]);
                
            } else {
                toast.error(`❌ Failed: ${result.message || "Something went wrong"}`);
            }
           
           // setMessages(prevMessages => [...prevMessages, botMessage]);
        } catch (error) {
            setMessages(prevMessages => [
                ...prevMessages,
                { user: "Spada", text: "Error: Unable to fetch response." }
            ]);
            console.error("Send error:", error);
        }
    
        setInput("");
        if (orderCount < 2) {
            setOrderCount(orderCount + 1);
        }
    };

    const handleKeyPress = (e) => {
        if (e.key === "Enter") {
            handleSendMessage();
        }
    };

    const handleClose = () => {
        setIsOpen(false);
        setMessages([]);
    };

        // **Scroll to the bottom of chat messages when a new message is added**

        useEffect(() => {

            messagesEndRef.current?.scrollIntoView({ behavior: "smooth" });
    
        }, [messages]);
    
    

    return (
        <>
            {/* Chat Toggle Button */}
            {!isOpen && (
                <button title="How can I help you?" className="chat-toggle" onClick={() => setIsOpen(true)}>
                    <img src="../../../assets/images/ai-talk.png" alt="User" className="aitalk" />
                    <span>How can I help you?</span>
                </button>
            )}

            {/* Chat Container */}
            {isOpen && (
                <motion.div 
                    className="chatbot-container"
                    initial={{ opacity: 0, scale: 0.8 }}
                    animate={{ opacity: 1, scale: 1 }}
                    transition={{ duration: 0.5 }}
                >
                    <div className="chat-header">
                        <div className="row align-items-center justify-content-between">
                            <div className="col-9">
                                <h5 className="mb-0"><i class="far fa-comments mr-2"></i> Chat</h5>
                                <h6 className="font-weight-normal mb-0 mt-2">Questions? chart with us!</h6>
                                <small style={{fontSize: "0.755em"}}  className="font-weight-normal text-warning">Was last active 16 hours ago</small>
                            </div>
                            <div className="col-auto ps-0">
                                <img style={{ width: "56px", margin:"3px 3px 0" }} src="../../../assets/images/spada-ai.png" alt="User" className="user-icon" />
                            </div>
                        </div>
                        <button className="close-btn" onClick={handleClose}>✖</button>
                    </div>

                    <div className="chat-messages">
                                {messages.map((msg, index) => (
                                    <motion.div
                                        key={index}
                                        className={`message ${msg.user === "User" ? "user" : "bot"}`}
                                        initial={{ opacity: 0, x: msg.user === "User" ? 50 : -50 }}
                                        animate={{ opacity: 1, x: 0 }}
                                        transition={{ duration: 0.3 }}
                                    >
                                        <img 
                                            src={msg.user === "User" ? "../../../assets/images/user-spada.png" : "../../../assets/images/spada-ai.png"} 
                                            alt={msg.user} 
                                            className="user-icon" 
                                        />
                                        <p>{msg.text}</p>
                                    </motion.div>
                                ))}
                                
                                {/* 🔹 Add this div to automatically scroll to the latest message */}
                                <div ref={messagesEndRef} />
                            </div>
                    
                    <div className="chat-input-container">
                        <input
                            type="text"
                            value={input}
                            onChange={(e) => setInput(e.target.value)}
                            onKeyDown={handleKeyPress}
                            placeholder="Type your message..."
                        />
                        <button className="send-button" onClick={handleSendMessage}>
                        <i class="fas fa-paper-plane"></i>
                        </button>
                    </div>
                </motion.div>
            )}
        </>
    );
};

export default SpadaChatbot;
